(() => {
  'use strict';
  const root=document.querySelector('[data-monolith-advisors]');
  if(!root || !root.querySelector('[data-advisor-photo-guide]')) return;
  const copy={
  "de": [
    "Welche Fotos helfen?",
    "Beschädigt: Zeige den ganzen Artikel und die beschädigte Stelle möglichst deutlich.",
    "Falscher Artikel: Zeige den erhaltenen Artikel und seinen Namen oder das Shade-Etikett.",
    "Artikel fehlt: Ein Foto der erhaltenen Artikel kann uns bei der Zuordnung helfen.",
    "Du kannst Fotos auch später nachreichen; bereits gesendete Bilder brauchst du nicht nochmals zu schicken.",
    "Wie geht es weiter?",
    "Unser Team prüft dein Anliegen und antwortet dir persönlich an die angegebene E-Mail-Adresse.",
    "Schau auch im Spam- oder Werbeordner nach unserer Antwort.",
    "Für Ergänzungen antworte möglichst auf dieselbe E-Mail. Nenne dabei deine Bestellnummer und, falls angezeigt, die Referenz dieser Anfrage.",
    "Bestätigung kopieren",
    "Bestätigung kopiert.",
    "Automatisches Kopieren ist hier nicht verfügbar. Markiere den Text und kopiere ihn selbst.",
    "Text für deine Unterlagen"
  ],
  "en": [
    "Which photos help?",
    "Damaged: Show the whole item and the damaged area as clearly as possible.",
    "Wrong item: Show what you received and its name or shade label.",
    "Missing item: A photo of the items received can help us identify the parcel contents.",
    "You can also provide photos later; you do not need to send pictures you have already shared again.",
    "What happens next?",
    "Our team reviews your enquiry and replies personally to the email address you provided.",
    "Check your spam or promotions folder for our reply too.",
    "For additions, reply to the same email where possible. Include your order number and, if shown, this enquiry’s reference.",
    "Copy confirmation",
    "Confirmation copied.",
    "Automatic copying is unavailable here. Select the text and copy it yourself.",
    "Text for your records"
  ],
  "fr": [
    "Quelles photos sont utiles ?",
    "Article abîmé : montrez l’article entier et la partie endommagée aussi clairement que possible.",
    "Mauvais article : montrez l’article reçu et son nom ou l’étiquette de la teinte.",
    "Article manquant : une photo des articles reçus peut nous aider à identifier le contenu du colis.",
    "Vous pouvez aussi envoyer les photos plus tard ; inutile de renvoyer celles déjà transmises.",
    "Et ensuite ?",
    "Notre équipe examine votre demande et vous répond personnellement à l’adresse e-mail indiquée.",
    "Vérifiez également les dossiers spam ou promotions.",
    "Pour compléter votre demande, répondez si possible au même e-mail. Indiquez votre numéro de commande et, si elle apparaît, la référence de cette demande.",
    "Copier la confirmation",
    "Confirmation copiée.",
    "La copie automatique est indisponible ici. Sélectionnez le texte et copiez-le vous-même.",
    "Texte à conserver"
  ],
  "it": [
    "Quali foto aiutano?",
    "Articolo danneggiato: mostra l’articolo intero e la parte danneggiata nel modo più chiaro possibile.",
    "Articolo sbagliato: mostra quello ricevuto e il nome o l’etichetta della tonalità.",
    "Articolo mancante: una foto degli articoli ricevuti può aiutarci a identificare il contenuto del pacco.",
    "Puoi inviare le foto anche in seguito; non occorre reinviare immagini già trasmesse.",
    "Che cosa succede adesso?",
    "Il team esamina la richiesta e risponde personalmente all’indirizzo email indicato.",
    "Controlla anche la cartella spam o promozioni.",
    "Per aggiungere informazioni, rispondi se possibile alla stessa email. Indica il numero d’ordine e, se presente, il riferimento della richiesta.",
    "Copia la conferma",
    "Conferma copiata.",
    "La copia automatica non è disponibile qui. Seleziona il testo e copialo manualmente.",
    "Testo da conservare"
  ],
  "es": [
    "¿Qué fotos ayudan?",
    "Artículo dañado: muestra el artículo completo y la zona dañada con la mayor claridad posible.",
    "Artículo equivocado: muestra lo recibido y su nombre o la etiqueta del tono.",
    "Artículo que falta: una foto de los artículos recibidos puede ayudarnos a identificar el contenido del paquete.",
    "Puedes añadir las fotos más adelante; no hace falta reenviar imágenes ya enviadas.",
    "¿Qué ocurre ahora?",
    "El equipo revisa tu consulta y responde personalmente al correo que has indicado.",
    "Revisa también las carpetas de spam o promociones.",
    "Para añadir información, responde al mismo correo cuando sea posible. Incluye tu número de pedido y, si aparece, la referencia de esta consulta.",
    "Copiar confirmación",
    "Confirmación copiada.",
    "La copia automática no está disponible aquí. Selecciona el texto y cópialo manualmente.",
    "Texto para guardar"
  ],
  "pl": [
    "Jakie zdjęcia pomogą?",
    "Uszkodzenie: pokaż cały artykuł i uszkodzone miejsce możliwie wyraźnie.",
    "Niewłaściwy artykuł: pokaż otrzymany produkt oraz jego nazwę lub etykietę odcienia.",
    "Brak artykułu: zdjęcie otrzymanych produktów może pomóc nam ustalić zawartość paczki.",
    "Zdjęcia możesz dosłać później; nie musisz ponownie wysyłać przekazanych już zdjęć.",
    "Co dalej?",
    "Zespół sprawdzi zgłoszenie i odpowie osobiście na podany adres e-mail.",
    "Sprawdź także folder spam lub oferty.",
    "Aby coś uzupełnić, odpowiedz w miarę możliwości na ten sam e-mail. Podaj numer zamówienia i, jeśli jest widoczny, numer referencyjny zgłoszenia.",
    "Kopiuj potwierdzenie",
    "Potwierdzenie skopiowane.",
    "Automatyczne kopiowanie jest tu niedostępne. Zaznacz tekst i skopiuj go samodzielnie.",
    "Tekst do zachowania"
  ],
  "sv": [
    "Vilka bilder hjälper?",
    "Skadad vara: visa hela varan och det skadade området så tydligt som möjligt.",
    "Fel vara: visa det du fick och namnet eller nyansetiketten.",
    "Saknad vara: ett foto av de mottagna varorna kan hjälpa oss att identifiera paketets innehåll.",
    "Du kan även skicka bilder senare; redan skickade bilder behöver du inte skicka igen.",
    "Vad händer nu?",
    "Vårt team granskar din fråga och svarar personligen till den e-postadress du angav.",
    "Titta även i skräppost- eller kampanjmappen efter vårt svar.",
    "Svara om möjligt i samma mejltråd för kompletteringar. Ange ordernummer och, om det visas, referensen för din fråga.",
    "Kopiera bekräftelsen",
    "Bekräftelsen kopierad.",
    "Automatisk kopiering är inte tillgänglig här. Markera texten och kopiera den själv.",
    "Text att spara"
  ],
  "fi": [
    "Millaiset kuvat auttavat?",
    "Vaurioitunut tuote: näytä koko tuote ja vauriokohta mahdollisimman selvästi.",
    "Väärä tuote: näytä saamasi tuote sekä sen nimi tai sävyetiketti.",
    "Puuttuva tuote: kuva saapuneista tuotteista voi auttaa paketin sisällön selvittämisessä.",
    "Voit lähettää kuvat myös myöhemmin; jo lähetettyjä kuvia ei tarvitse lähettää uudelleen.",
    "Mitä seuraavaksi?",
    "Tiimimme käsittelee viestisi ja vastaa henkilökohtaisesti antamaasi sähköpostiosoitteeseen.",
    "Tarkista myös roskaposti- ja tarjouskansiot.",
    "Vastaa lisätiedoilla mahdollisuuksien mukaan samaan sähköpostiketjuun. Mainitse tilausnumero ja, jos se näkyy, tämän yhteydenoton viite.",
    "Kopioi vahvistus",
    "Vahvistus kopioitu.",
    "Automaattinen kopiointi ei ole tässä käytettävissä. Valitse teksti ja kopioi se itse.",
    "Teksti talteen"
  ],
  "nl": [
    "Welke foto’s helpen?",
    "Beschadigd: laat het hele artikel en de beschadiging zo duidelijk mogelijk zien.",
    "Verkeerd artikel: laat zien wat je kreeg en de naam of het kleuretiket.",
    "Ontbrekend artikel: een foto van de ontvangen artikelen kan helpen de inhoud van het pakket vast te stellen.",
    "Je kunt foto’s ook later nasturen; eerder gestuurde foto’s hoef je niet opnieuw te sturen.",
    "Hoe gaat het verder?",
    "Ons team bekijkt je vraag en antwoordt persoonlijk op het opgegeven e-mailadres.",
    "Kijk ook in je spam- of reclamemap naar ons antwoord.",
    "Antwoord voor aanvullingen indien mogelijk op dezelfde e-mail. Vermeld je bestelnummer en, indien getoond, de referentie van deze vraag.",
    "Bevestiging kopiëren",
    "Bevestiging gekopieerd.",
    "Automatisch kopiëren is hier niet beschikbaar. Selecteer de tekst en kopieer die zelf.",
    "Tekst voor je administratie"
  ]
};
  const t=copy[(root.dataset.locale||'en').split('-')[0]]||copy.en;
  const q=name=>root.querySelector('[data-advisor-'+name+']');
  q('photo-guide-title').textContent=t[0];q('photo-guide-note').textContent=t[4];
  const guide=q('photo-guide');
  let previousCase='';
  const updatePhotoGuide=()=>{
    const kind=q('photos').dataset.case;
    const index={damaged:1,wrong:2,missing:3}[kind];
    guide.hidden=!index;
    q('photo-guide-case').textContent=index?t[index]:'';
    if(kind!==previousCase){guide.open=false;previousCase=kind;}
  };
  root.addEventListener('monolith:case-change',updatePhotoGuide);updatePhotoGuide();
  q('followup-title').textContent=t[5];
  q('followup-steps').replaceChildren(...[6,7,8].map(i=>{const li=document.createElement('li');li.textContent=t[i];return li;}));
  const button=q('success-copy'),status=q('success-copy-status'),fallback=q('success-copy-fallback'),text=q('success-copy-text');
  button.textContent=t[9];q('success-copy-label').textContent=t[12];
  const reset=()=>{status.textContent='';fallback.hidden=true;text.value='';};
  let copying=false;
  button.addEventListener('click',async()=>{
    if(copying || root.dataset.advisorScreen!=='success')return;
    // Copy only the confirmed fields visible on the success screen, never hidden form data.
    const content=['success-title','success-topic','success-detail','success-reference','success-reply']
      .map(name=>q(name)).filter(e=>e&&!e.hidden).map(e=>e.textContent.trim()).filter(Boolean).join('\n');
    copying=true;button.disabled=true;reset();
    try{
      if(!navigator.clipboard?.writeText)throw new Error('clipboard');
      await navigator.clipboard.writeText(content);
      status.textContent=t[10];
    }catch{
      text.value=content;fallback.hidden=false;status.textContent=t[11];text.focus();text.select();
    }finally{copying=false;button.disabled=false;}
  });
  root.addEventListener('monolith:view',event=>{if(event.detail?.name!=='success')reset();});
  root.addEventListener('monolith:reset',reset);
})();

